export default "__VITE_ASSET__Cko8lRWG__"